angular.module('myApp.services')
    .factory('speechRecognitionManager', ['$rootScope', '$timeout', function($rootScope, $timeout) {
        var isDebug  = false;
        var isRecognizeSpeech = false;
        var statuses = {
            'progress'  : 'progress',
            'failed'    : 'failed',
            'done'      : 'done',
            'endOfAudio' : 'end-of-audio'
        };
        var transcriptions = {};

        var setStatus       = function(qId, status) {
            if (!(qId in transcriptions)) {
                transcriptions[qId] = {
                    'status'    : statuses.progress,
                    'text'      : ''
                };
            }
            transcriptions[qId].status = status;
            $rootScope.$broadcast("speechRecognitionStatus", {'qId': qId, 'status': status});
        };
        var addTranscription = function(qId, text) {
            if ((qId in transcriptions)) {
                transcriptions[qId].text += text;
            }
        };
        var emitSpeechFiles = function(data) {
            if (data && ('qId' in data) && isRecognizeSpeech) {
                var qId = parseInt(data.qId);
                setStatus(qId, statuses.progress);
                log("Emit file to speech recognition");
                /*socket.emit("user-media-audio-speech-files", data, function (err, retData) {
                    if (err) {
                        log(err);
                        setStatus(qId, statuses.failed);
                    } else {
                        log("Flac file for speech recognition was saved and recognition is in progress");
                        setStatus(qId, statuses.progress);
                    }
                });*/
            }
        };
        var log = function(message, data) {
            if (isDebug && message) {
                if (data) {
                    console.log(message, data);
                } else {
                    console.log(message);
                }
            }
        };
        return {
            emitFileToRecognize: function(data) {
                emitSpeechFiles(data);
            },
            setEndOfAudio: function(data) {
                if (data && ('qId' in data) && isRecognizeSpeech) {
                    var qId = parseInt(data.qId);
                    log("Set speech recognition result End of Audio", data);
                    setStatus(qId, statuses.endOfAudio);
                }
            },
            setRecognitionResult: function(data) {
                if (data && ('qId' in data) && ('transcription' in data) && ('error' in data) && isRecognizeSpeech) {
                    var qId = parseInt(data.qId);
                    log("Set speech recognition result", data);
                    if (data.error) {
                        setStatus(qId, statuses.failed);
                    } else {
                        addTranscription(qId, data.transcription);
                        $timeout(function() {
                            //Just to be sure that all transcriptions are got
                            setStatus(qId, statuses.done);
                        }, 2000);
                    }
                }
            },
            getRecognitionResult: function(qId) {
                qId = parseInt(qId);
                if (qId in transcriptions) {
                    return transcriptions[qId].text;
                }
                return "";
            },
            resetRecognitionResult: function(qId) {

            },
            setIsRecognizeSpeech: function(isRecognize) {
                isRecognizeSpeech = !!isRecognize;
            },
            isRecognizeSpeech: function() {
                return isRecognizeSpeech;
            },
            statuses: statuses
        }
    }]);